import { Component, Injector, OnInit } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { riskLevelOptions } from '../../services/ref';

import { UntilDestroy } from '@ngneat/until-destroy';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@UntilDestroy()
@Component({
    selector: 'investment-period-form',
    templateUrl: './investment-period-form.component.html',
    styleUrls: ['./investment-period-form.component.scss'],
    standalone: false
})
export class InvestmentPeriodFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  options = riskLevelOptions;
  error: ValidationErrors = null;
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    protected injector: Injector,
  ) {
    super(formConstructor, injector);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
